<template>
  <el-dialog title="选择关联合同" class="flow-dialog" :visible.sync="dialogVisible" width="80%" top="5%" @close="onClose"
  >
    <div class="content-main-box content-main-box2"
    >
      <div class="search-area"
      >
        <el-row :gutter="24"
        >
          <el-col :span="8"
            ><div class="search-area-div">甲方名称：</div>
            <el-select size="mini" filterable clearable v-model="searchForm.tenantGuid" class="ipt-sty" placeholder="请选择">
              <el-option v-for="item in tenantList" :key="item.guid" :label="item.tenantName" :value="item.guid"></el-option>
            </el-select>
          </el-col>
          <el-col :span="8"
            ><div class="search-area-div">乙方名称：</div>
            <el-select size="mini" filterable clearable v-model="searchForm.serviceTenantGuid" class="ipt-sty" placeholder="请选择">
              <el-option v-for="item in serviceTenantList" :key="item.guid" :label="item.tenantName" :value="item.guid"></el-option>
            </el-select>
          </el-col>
          <el-col :span="8"
            ><div class="search-area-div">合同编码：</div>
            <el-input size="mini" v-model="searchForm.contractCode" class="ipt-sty" placeholder="请输入"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mt15"
        >
          <el-col :span="8"
            ><div class="search-area-div">合同名称：</div>
            <el-input size="mini" v-model="searchForm.contractName" class="ipt-sty" placeholder="请输入"></el-input>
          </el-col>
          <el-col :span="16" class="search-btn-box"
            ><el-button size="mini" type="info" @click="getList(1)">搜索</el-button>
            <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
          </el-col>
        </el-row>
      </div>
      <el-table :data="tableData" stripe border v-loading="loading" :height="tableHeight"
        >
        <el-table-column label="" width="80" header-align="center" align="center"
          >
          <template slot-scope="scope"
            ><el-checkbox
              :value="currentSelectedGuid == scope.row.guid"
              @change="handleCheckChange(scope.row, $event)"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column prop="contractName" label="合同名称" show-overflow-tooltip header-align="center" align="left"
          min-width="180"><template slot-scope="scope">{{ scope.row.contractName || '-' }}</template></el-table-column>
        <el-table-column prop="contractCode" label="合同编码" show-overflow-tooltip header-align="center" align="left"
          min-width="160"><template slot-scope="scope">{{ scope.row.contractCode || '-' }}</template></el-table-column>
        <el-table-column prop="tenantName" label="甲方名称" show-overflow-tooltip header-align="center" align="left"
          min-width="180"><template slot-scope="scope">{{ scope.row.tenantName || '-' }}</template></el-table-column>
        <el-table-column prop="serviceTenantName" label="乙方名称" show-overflow-tooltip header-align="center" align="left"
          min-width="180"><template slot-scope="scope">{{ scope.row.serviceTenantName || '-' }}</template></el-table-column>
        <el-table-column prop="signDate" label="签约时间" header-align="center" align="left" width="110"><template
            slot-scope="scope">{{ scope.row.signDate | getDate }}</template></el-table-column>
        <el-table-column prop="validityDate" label="合同有效期" header-align="center" align="left" width="130"><template
            slot-scope="scope">{{ scope.row.validityDate | getDate }}</template></el-table-column>
        <el-table-column prop="chargeRate" label="收费比例(%)" header-align="center" align="center" width="100"><template
            slot-scope="scope">{{ scope.row.chargeRate ? $options.filters.numDigit(scope.row.chargeRate) : '-' }}</template></el-table-column>
        <el-table-column prop="sendTaxDeduction" label="下发扣除税点(%)" header-align="center" align="center" width="120"><template
            slot-scope="scope">{{ scope.row.sendTaxDeduction ? $options.filters.numDigit(scope.row.sendTaxDeduction) : '-' }}</template></el-table-column>
      </el-table>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100, 200]"
        :current-page="searchForm.pageIndex"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchForm.totalRows"
      >
      </el-pagination>
    </div>
    <div slot="footer"
      ><el-button size="small" @click="onClose">取消</el-button>
      <el-button type="primary" size="small" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { ApproveStateEnum, ContractUseStateEnum } from '../enum';
export default {
  name: 'ContractSelectDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedGuid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      tableHeight: 350,
      currentSelectedGuid: '',
      tenantList: [], // 甲方
      serviceTenantList: [], // 乙方
      searchForm: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        contractName: '',
        contractCode: '',
        tenantGuid: '', // 甲方
        serviceTenantGuid: '', // 乙方
        approveState: ApproveStateEnum.pass,
        contractUseStateList: [ContractUseStateEnum.EFFECTIVE],
        // currentTenantGuid: localStorage.guid,
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.currentSelectedGuid = this.selectedGuid;
        this.getTenantList();
        this.getServiceTenantList();
        this.getList(1);
      }
    },
  },
  methods: {
    async getList(type) {
      if (type == 1) {
        this.searchForm.pageIndex = 1;
      }
      this.loading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msCustomerService}/contract/list`,
        this.searchForm
      );
      this.loading = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.tableData = data.data.records || [];
      this.searchForm.totalPage = data.data.totalPages;
      this.searchForm.totalRows = data.data.totalRows;
    },
    async getTenantList() {
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['010201', '9901', '0101'],
        bizState: 'Y'
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msCustomerService}/tenant/data/get`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.tenantList = data.data.records || [];
    },
    async getServiceTenantList() {
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ["9901", "9903", "9904"],
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msCustomerService}/tenant/data/get`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.serviceTenantList = data.data.records || [];
    },
    emptySearch() {
      this.searchForm = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        contractName: '',
        contractCode: '',
        tenantGuid: '', // 甲方
        serviceTenantGuid: '', // 乙方
        approveState: ApproveStateEnum.pass,
        contractUseStateList: [ContractUseStateEnum.EFFECTIVE],
        // currentTenantGuid: localStorage.guid,
      };
      this.getList(1);
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchForm.pageIndex = val;
      this.getList();
    },
    handleCheckChange(row, checked) {
      this.currentSelectedGuid = checked ? row.guid : '';
    },
    confirm() {
      if (!this.currentSelectedGuid) {
        this.$message.error('请选择合同');
        return;
      }
      let row = this.tableData.find((item) => item.guid == this.currentSelectedGuid);
      this.$emit('select', row);
      this.$emit('update:visible', false);
    },
    onClose() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style scoped>
.search-area [class*="el-col-"] {
  display: flex;
}
.search-area .search-btn-box {
  align-items: center;
  justify-content: flex-start;
}
.search-area-div {
  width: 80px;
  text-align: right;
  line-height: 28px;
}
.ipt-sty {
  flex: 1;
}
.mt15 {
  margin-top: 15px;
}
.pt {
  padding-top: 10px;
}
.pb {
  padding-bottom: 10px;
}
.content-main-box2 {
  height: 40%;
  overflow-x: hidden;
}
.content-main-box2 .search-area {
  padding: 16px 0px;
}
.content-main-box2 .el-table {
  border-left: 1px solid #d8d8d8;
  border-right: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
}
/deep/ .el-dialog__body {
  padding: 10px 20px;
}
</style>
